import React from "react";
import { BRAND } from "./data";

const COL_PROPERTIES = [
  "Bungalows & Villas",
  "Penthouses",
  "Luxury Apartments",
  "Farmhouses",
  "Commercial",
  "Plots & Land",
  "Off-Market Inventory",
];
const COL_LOCATIONS = [
  "Lutyens' Delhi",
  "South Delhi",
  "Gurugram",
  "Noida",
  "Greater Noida",
  "Pan-India",
  "International (Soon)",
];
const COL_COMPANY = [
  "About & Legacy",
  "The Dealroom",
  "Numbardar Estates",
  "Advisory Services",
  "Interiors (Soon)",
  "Build (Soon)",
  "Client Stories",
  "Contact",
];

const ColLink = ({ children }) => (
  <li>
    <a
      href="#contact"
      className="font-ui text-[12px] hover:text-num-gold transition-colors"
      style={{ color: "rgba(247,243,236,0.55)" }}
    >
      {children}
    </a>
  </li>
);

const Footer = () => (
  <footer className="border-t border-num-gold/20" style={{ backgroundColor: "#1C0606" }} data-testid="footer">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4 space-y-5">
        <img
          src="/brand/hnmb-logo.tight.svg"
          alt=""
          aria-hidden="true"
          draggable={false}
          className="filter-cream block"
          style={{ height: 56, width: "auto" }}
        />
        <div>
          <div className="font-display text-[22px] text-num-cream leading-tight">
            {BRAND.name}
          </div>
          <div
            className="font-ui text-[8px] uppercase mt-1.5 text-num-gold"
            style={{ letterSpacing: "0.44em" }}
          >
            Luxury Real Estate · Delhi NCR · Est. 1795
          </div>
        </div>
        <p className="font-ui font-light text-[12px] leading-[1.85] max-w-[340px]" style={{ color: "rgba(247,243,236,0.4)" }}>
          A generational institution rooted in custodianship — bringing portfolio thinking,
          discretion and craft to luxury real estate across India.
        </p>
      </div>

      <div className="lg:col-span-2">
        <div className="font-ui text-[9px] uppercase track-eyebrow text-num-gold mb-5">
          Properties
        </div>
        <ul className="space-y-2.5">
          {COL_PROPERTIES.map((l) => (
            <ColLink key={l}>{l}</ColLink>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-3">
        <div className="font-ui text-[9px] uppercase track-eyebrow text-num-gold mb-5">
          Locations
        </div>
        <ul className="space-y-2.5">
          {COL_LOCATIONS.map((l) => (
            <ColLink key={l}>{l}</ColLink>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-3">
        <div className="font-ui text-[9px] uppercase track-eyebrow text-num-gold mb-5">
          Company
        </div>
        <ul className="space-y-2.5">
          {COL_COMPANY.map((l) => (
            <ColLink key={l}>{l}</ColLink>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-num-gold/15">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12" style={{ paddingTop: 60, paddingBottom: 24 }}>
        {/* Closing seal — emblem + brand line + metadata, centered */}
        <div className="flex flex-col items-center gap-4 text-center" style={{ marginBottom: 60 }}>
          <img
            src="/brand/hnmb-logo.tight.svg"
            alt="House of Numbardar"
            draggable={false}
            className="filter-cream block"
            style={{ height: 64, width: "auto" }}
            data-testid="footer-seal"
          />
          <div
            className="font-display"
            style={{ fontSize: 16, color: "rgba(250,246,239,0.5)" }}
          >
            House of Numbardar
          </div>
          <div
            className="font-ui uppercase text-num-gold"
            style={{ fontSize: 9, letterSpacing: "0.32em", opacity: 0.6 }}
          >
            Delhi NCR · Est. 1795 · {BRAND.rera}
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-4 lg:justify-between">
          <p className="font-ui text-[11px]" style={{ color: "rgba(247,243,236,0.4)" }}>
            © {new Date().getFullYear()} House of Numbardar Realty Pvt. Ltd. All rights reserved.
          </p>
          <ul className="flex items-center gap-6 font-ui text-[11px]" style={{ color: "rgba(247,243,236,0.4)" }}>
            <li><a href="#" className="hover:text-num-gold transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-num-gold transition-colors">Terms of Use</a></li>
            <li><a href="#" className="hover:text-num-gold transition-colors">Disclaimer</a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
